var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('Form', {
    attrs: {
      "url": "/tributacao/create",
      "tributacao": {}
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };